{
    "GenericAdminFilterLanguage_CME_LABEL": "CME",
    "GenericAdminFilterLanguage_TELSYS_LABEL": "Telefonieserver",
    "GenericAdminFilterLanguage_PARTITION_LABEL": "Partitie",
    "GenericAdminFilterLanguage_CRM_TYPE_LABEL": "CRM-type",
    "GenericAdminFilterLanguage_INCLUDE_CHILD_CMES_LABEL": "Inclusief onderliggende CME-items",
    "GenericAdminFilterLanguage_SEARCH_LABEL": "Zoekopdracht",
    "NAME": "GenericAdminFilterLanguage",
    "GenericAdminFilterLanguage_OPTION_ALL_LABEL": "Alle",
    "GenericAdminFilterLanguage_OPTION_ANY_LABEL": "Elk",
    "GenericAdminFilterLanguage_OPTION_NONE_LABEL": "Geen",
    "GenericAdminFilterLanguage_PLEASE_SELECT_OPTION_TO_SHOW_RESULTS": "Selecteer een optie om de resultaten weer te geven."
}